var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.permissionItem.title)))]),_c('RolePermissionsState',{attrs:{"sub-items":_vm.permissionItem.subItems,"role-permissions":_vm.permissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }